<template>
    <div class="award-container">
        <div class="award-title">
            <img
                src="../img/award-title.png"
                alt="png">
        </div>
        <div class="award-content">
            <!-- <AwardInfo /> -->
            <div class="award-icon-content">
                <div class="award-box">
                    <div 
                        v-for="item in award_list" 
                        :key="item.index" 
                        :class="{'award_chosen':item.chosen,'award_item_luckdraw':item.type===0}" 
                        class="award_item">
                        <div 
                            v-if="item.type==1" 
                            class="award_item_inner">
                            <img 
                                v-if="item.award_icon"
                                :src="item.award_icon"
                                class="award_icon" 
                                alt="奖品图">
                            <div 
                                v-else 
                                class="award_icon" />
                            <div class="award_title">{{ item.award_title }}</div>
                        </div>
                        <div 
                            v-if="item.type==0" 
                            class="award_item_inner" 
                            @click="beginAward">
                            <img 
                                class="award_btn" 
                                src="../img/luckdraw.png"
                                alt="png">
                            <div
                                v-if="is_login"
                                class="award_title award_btn_title">还有{{ leftTimes }}次抽奖机会</div>
                            <div
                                v-else
                                class="award_title award_btn_title">登录</div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="my-award"
                @click="getRecordList(true)">我的奖励</div>
        </div>
    </div>  
</template>
<script>
// comp
import AwardInfo from "./AwardInfo";

// api
import { luckdraw } from "../api/lottery.api.js";


export default {
    name: "Award",
    components: {
        AwardInfo,
    },
    props: {
        award_lists: {
            type: Array,
            default: function(){
                return [
                ];
            }
        },
        is_login: {
            type: Boolean,
            default: false
        },
        lottery_balance: {
            type: [Number, String],
            default: 0,
        },
        activity_name: {
            type: String,
            default: ""
        },
        user_record_list: {
            type: Array,
            default: function(){
                return [];
            }
        }
    },
    data() {
        return {
            canAward: true,
            award_list: [],

            leftTimes: 0, // 剩余次数
            stop_num: 1, // 抽奖停止位置

            stopAward: {},  // 抽奖所中的奖品信息

            record_list: [], // 记录列表

        };
    },   
    watch: {
        lottery_balance(newVal) {
            this.leftTimes = newVal;
        },
        award_lists: {
            deep: true,
            handler() {
                this.createAward();
            }
        }
    },
    created: function() {
        this.createAward();
        this.getRecordList();
    },
    methods: {
        // 获取记录列表
        getRecordList(status=false){
            if(!this.is_login){
                if(status){
                    this.$emit("toLogin", "must");
                }
                return ;
            }
            this.record_list = this.user_record_list;
            if(status){
                this.$emit("openAwardDialog", status, this.record_list, this.stopAward);
            }
        },
        scrollToWhere(s, t) {
            let sp = 10; //也可根据当前scrollTop动态改变sp的值，从而实现加速和减速滚动的效果
            let cont = Number.parseInt(t / sp);
            let oneLong = s / cont;
            let timer = setInterval(()=>{
                if(cont > 0){
                    cont--;
                    window.scrollBy(0,oneLong);
                }else{
                    clearInterval(timer);
                }
                
            },sp);
        },
        // 生成抽奖转盘
        createAward() {
            this.leftTimes = this.lottery_balance;
            // TODO:data需要换成接口返回奖品
            let data = this.deepClone(this.award_lists);
            // 防止奖品数量过多
            data.sort(function(a, b){
                return a.priority - b.priority;
            });
            data = data.splice(0, 8);

            data.splice(4, 0, { award_icon: "", award_title: "抽奖按钮" });
            // type: 0-抽奖按钮，1-奖品
            data = data.map((item, index) => {
                return {
                    ...item,
                    index,
                    num: createNum(index),
                    chosen: index === 0 ? true : false,
                    type: index == 4 ? 0 : 1
                };
            });

            function createNum(index) {
                if (index <= 3) {
                    return index + 1;
                } else {
                    return index == 4 ? -1 : index;
                }
            }
            // 抽奖时 循环转动
            let temp3 = data[3],
                temp5 = data[5],
                temp6 = data[6],
                temp7 = data[7],
                temp8 = data[8];

            data[3] = temp8;
            data[5] = temp3;
            data[6] = temp7;
            data[7] = temp6;
            data[8] = temp5;

            this.award_list = data;
        },

        // 点击开始抽奖
        beginAward() {
            if(!this.is_login){
                this.$emit("toLogin", "must");
                return ;
            }
            if(!this.canAward) return;
            this.$emit("doTrack", "PayActivityBtnClk",  {
                ButtonName: "开始抽奖",
                H5Page: location.href
            });
            if(!this.leftTimes) {
                // this.showToast("次数不足");
                this.$emit("openVipHandler");
            } else {
                this.canAward = false;
                luckdraw({ 
                    activity_name: this.activity_name,
                    xdevice: window.__gvalkkmh.sys.device_id
                }).then(res => {
                    let { code, data, message } = res.data;
                    if (code !== 200)   {
                        this.canAward = true;
                        return this.showToast(message);
                    }
                    this.left_lottery_balance = data.left_lottery_balance;
                    this.stopAward = {
                        award_name: data.award_name,
                        award_type: data.award_type,
                        award_title: data.award_title,
                        award_icon: data.award_icon,
                        award_desc: data.award_desc,
                        award_url: ((data.target_info || {}).award_target || {}).target_web_url || "",
                    };
                    this.award_list.map((item) => {
                        if(item.award_name == data.award_name) {
                            this.stop_num = item.num;
                            this.stopAward.award_url = ((item.target_info || {}).award_target || {}).target_web_url || "" ;
                        }
                    });
                    this.$emit("getUserRecordList");
                    this.begin();
                }).catch(err => {
                    this.showToast(err.message || err || "未知错误");
                });
            }
        }, 

        // 开始抽奖
        begin() {
            let _this = this;
            this.leftTimes--;
            let chosen_num = 0;
            let speed = 80; //初速度
            let circle = 0; //圈数
            let item_num = 0; //转出的块数
            let stop_num = this.stop_num; //停止位置
            let timer = null;

            timer = setInterval(move, speed);

            function move() {
                //选中块
                if (chosen_num < 8) {
                    chosen_num++;
                } else {
                    circle++;
                    item_num = 8 * circle;
                    chosen_num = 1;
                }

                //块数
                if (item_num <= 8) {
                    speed = 60;
                } else if (item_num <= 16) {
                    speed = 45;
                } else if (item_num <= 24) {
                    speed = 45;
                } else if (item_num <= 32) {
                    speed = 45;
                } else if (item_num <= 40) {
                    speed = 45;
                } else if (item_num <= 48) {
                    speed = 45;
                } else if (item_num <= 56) {
                    speed = 50;
                } else if (item_num <= 64) {
                    //第8圈
                    speed = 90;
                }

                clearInterval(timer);
                timer = setInterval(move, speed);

                _this.award_list.forEach(item => {
                    if (item.num == chosen_num) {
                        item.chosen = true;

                        if (item_num > 64 && item_num <= 72) {
                            //第9圈开始减速
                            speed += 40;
                            if (stop_num >= 6 && chosen_num == stop_num) {
                                //奖品6之后的不需要再转下一圈就可以停止
                                chosen_num = 1;
                                speed = 80;

                                //显示得奖页面
                                // TODO:
                                let timer1 = setTimeout(() => {
                                    _this.targetAwardMask();
                                    window.clearTimeout(timer1);
                                }, 500);

                                clearInterval(timer);
                            }
                        } else if (
                            item_num >= 72 &&
                            chosen_num == stop_num &&
                            stop_num < 6
                        ) {
                            //奖品6之前的需要再转下一圈才可以停止
                            chosen_num = 1;
                            speed = 80;

                            //显示得奖页面
                            // TODO:
                            let timer2 = setTimeout(() => {
                                _this.targetAwardMask();
                                window.clearTimeout(timer2);
                            }, 500);

                            clearInterval(timer);
                        }
                    } else {
                        item.chosen = false;
                    }
                });
            }
        },
        // 获奖弹窗
        targetAwardMask(){
            this.canAward = true;
            this.$emit("openAwardDialog", false, [], this.stopAward);
        },
        // toast展示
        showToast(text = "") {
            this.$emit("showToast", text);
        },
        // 使用递归的方式实现数组、对象的深拷贝
        deepClone(obj) {
            // 判断拷贝的要进行深拷贝的是数组还是对象，是数组的话进行数组拷贝，对象的话进行对象拷贝
            var objClone = Array.isArray(obj) ? [] : {};
            // 进行深拷贝的不能为空，并且是对象或者是
            if (obj && typeof obj === "object") {
                for (let key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        if (obj[key] && typeof obj[key] === "object") {
                            objClone[key] = this.deepClone(obj[key]);
                        } else {
                            objClone[key] = obj[key];
                        }
                    }
                }
            }
            return objClone;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/vws.scss';
.award-title{
    width: vws(586px);
    height: vws(42px);
    margin: 0 auto;
    img {
        width: 100%;
        height: 100%;
        display: block;
    }
}

.award-content {
    width: vws(700px);
    background-color: #FEF6E4;
    margin: vws(15px) auto vws(80px);
    overflow: hidden;
    box-sizing: border-box;
    padding: vws(37px) vws(37px) vws(78px);
    border-radius: vws(20px);
    position: relative;
    .my-award{
        position: absolute;
        right: 0;
        bottom: vws(24px);
        width: vws(142px);
        height: vws(48px);
        line-height: vws(48px);
        text-align: center;
        font-size: vws(24px);
        color: #442509;
        background: url("../img/my-award.png") no-repeat;
        background-size: 100% 100%;
    }
}

.award-icon-content {
    width: vws(628px);
    background-color: #FFEDC0;
    box-sizing: border-box;
    padding: vws(20px);
    .award-box{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-content: space-between;
        height: vws(488px);
    }
    .award_item {
        width: vws(180px);
        height: vws(148px);
        background-color: #fff;
        border-radius: vws(8px);
        border: vws(4px) solid #fff;
    }
    .award_item_luckdraw{
        width: vws(188px);
        height: vws(156px);
        border: none;
    }
    .award_chosen {
        background-color: #FFF8B5;
        border: vws(4px) solid #FFAC49;
    }
    .award_item_inner {
        position: relative;
    }
    .award_icon {
        width: vws(180px);
        height: vws(123px);
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: vws(8px) vws(8px) 0 0 ;
    }
    .award_title {
        width: 100%;
        font-size: vws(24px);
        color: #4e494a;
        font-weight: bold;
        text-align: center;
        line-height: 1.12;
        top: vws(117px);
        position: absolute;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .award_btn_title {
        top: vws(110px);
        color: #fff;
        font-size: vws(20px);
        line-height: normal;
        // transform: scale(0.83, 0.83);
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/native/pay/vip/link_vip_multiple/comp/Award.vue